export const ReferenceConst = {
    auditLogType: {
        LINE_CHARGE_RELATED: 'Line Charge Related',
        COUNTER_CHARGE_RELATED: 'Counter Charge Related',
        WAIVER_RELATED: 'Waiver Related',
        COLLECTION_RELATED: 'Collection Related',
        MAINTENANCE_RELATED: 'Maintenance Related',
    },
    auditLogIncident: {
        CHANGE_STATE_R_TO_MT_IND: "Update of the charge record State to 'MT'",
        CHANGE_STATE_R_TO_W_IND: "Update of the charge record State from 'R' to 'W' (Waiver Initiation)",
        CHANGE_STATE_W_TO_R_IND: "Update of the charge record State from 'W' to 'R' (Edit of Waiver)",
        CHANGE_BILL_TO_COMPANY_IND: "Update of the charge record Bill To Company",
        CHANGE_CHARGE_ON_COMPANY_IND: "Update of the charge record Charge On Company",
        CONFIRM_DRAFT_INVOICE_IND: "Confirmation of the draft invoice",
        DELETE_COLLECTION_PAYMENT_IND: "Deletion of the collection payment record",
        CREATE_COMPANY_IND: "Creation of a company under Company Maintenance",
        CREATE_MASTER_FSP_IND: "Creation of a FSP record under the Master FSP Maintenance",
    },

}